// import Button from "@app/components/button";
// import Checkbox from "@app/components/checkbox";
// import { FormControl } from "@app/components/form-control";
// import Input from "@app/components/input";
// import { addToast } from "@app/components/toast/toast.service";
// import VerificationCodeModal from "@app/components/verification-code-modal";
// import VerificationModal from "@app/components/verification-modal";
// import {
//   ImageTypes,
//   IsVerifyName,
//   TypeCard,
//   VerificationMethod,
// } from "@app/constants";
// import AccountService from "@app/services/http/account.service";
// import AuthService from "@app/services/http/auth.service";
// import { openPortalDialog } from "@app/services/modal.service";
// import { GlobalState } from "@app/store";
// import { MyInfoEpic } from "@app/store/my-info";
// import { VerifyAccountInitialValues, VerifyAccountRequest } from "@app/types";
// import { verifyValidationSchema } from "@app/validations/account.validation";
// import useDestroy from "@core/hooks/use-destroy.hook";
// import useObservable from "@core/hooks/use-observable.hook";
// import { Form, Formik, FormikContextType } from "formik";
// import { ChangeEvent, createRef, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import SignaturePad from "react-signature-pad-wrapper";
// import EkycComponent from "./ekyc.component";

// function IdentityVerification() {
//   const [frontCard, setFrontCard] = useState<File>();
//   const [frontCardError, setFrontCardError] = useState("");
//   const [frontCardObj, setFrontCardObj] = useState("");

//   const [backCard, setBackCard] = useState<File>();
//   const [backCardError, setBackCardError] = useState("");
//   const [backCardObj, setBackCardObj] = useState("");

//   const [portraitCard, setPortraitCard] = useState<File>();
//   const [portraitCardError, setPortraitCardError] = useState("");
//   const [portraitCardObj, setPortraitCardObj] = useState("");

//   const signaturePadRef = createRef<SignaturePad>();
//   const formRef = createRef<FormikContextType<VerifyAccountInitialValues>>();

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { destroy$ } = useDestroy();
//   const { subscribeOnce } = useObservable();
//   const { myInfo } = useSelector(selectMyInfo);

//   useEffect(() => {
//     if (myInfo.kyc === 0) {
//       navigate("/");
//     }
//   }, [myInfo]);

//   useEffect(() => {
//     if (myInfo._id && formRef.current) {
//       formRef.current.setFieldValue("email", myInfo.email);
//       formRef.current.setFieldValue("phone", myInfo.phone);
//     }
//   }, [myInfo]);

//   const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
//     const cardName = e.target.name as TypeCard;

//     if (!e.target.files?.length) {
//       e.target.value = "";

//       return;
//     }

//     if (!ImageTypes.includes(e.target.files[0].type)) {
//       addToast({ text: "Chỉ tải lên định dạng ảnh", status: "inValid" });
//     }

//     const file = e.target.files[0];

//     switch (cardName) {
//       case TypeCard.FRONT_CARD: {
//         setFrontCard(file);
//         const frontCardObj = URL.createObjectURL(file);

//         setFrontCardObj(frontCardObj);
//         setFrontCardError("");
//         break;
//       }
//       case TypeCard.BACK_CARD: {
//         setBackCard(file);
//         const backCardObj = URL.createObjectURL(file);

//         setBackCardObj(backCardObj);
//         setBackCardError("");
//         break;
//       }
//       case TypeCard.PORTRAIT_CARD: {
//         setPortraitCard(file);
//         const portraitCardObj = URL.createObjectURL(file);

//         setPortraitCardObj(portraitCardObj);
//         setPortraitCardError("");
//         break;
//       }
//     }

//     e.target.value = "";
//   };

//   const handleSubmit = (values: VerifyAccountInitialValues) => {
//     if (!frontCard) {
//       setFrontCardError("Yêu cầu chọn ảnh tải lên");

//       return;
//     }

//     if (!backCard) {
//       setBackCardError("Yêu cầu chọn ảnh tải lên");

//       return;
//     }

//     if (!portraitCard) {
//       setPortraitCardError("Yêu cầu chọn ảnh tải lên");

//       return;
//     }

//     const verificationModalObs = openPortalDialog(VerificationModal);

//     verificationModalObs.afterClosed().subscribe((data) => {
//       if (data?.verificationMethod) {
//         if (data.verificationMethod[0] === VerificationMethod.EMAIL) {
//           subscribeOnce(AuthService.getOtp(), () => {
//             handleOpenVerificationCodeModal(values);
//           });
//         }
//       }
//     });
//   };

//   const handleOpenVerificationCodeModal = (
//     values: VerifyAccountInitialValues
//   ) => {
//     if (!signaturePadRef.current) {
//       return;
//     }

//     const signatureImageURL = signaturePadRef.current.toDataURL();

//     const verificationCodeModalObs = openPortalDialog(VerificationCodeModal);

//     verificationCodeModalObs.afterClosed().subscribe((data) => {
//       if (data?.code) {
//         if (frontCard && backCard && portraitCard && signatureImageURL) {
//           const verifyAccountRequest: VerifyAccountRequest = {
//             front_card: frontCard,
//             back_card: backCard,
//             portrait: portraitCard,
//             signature_image: signatureImageURL,
//             fullName: values.fullName,
//             dob: values.dob,
//             id: values.id,
//             issueDate: values.issueDate,
//             issuePlace: values.issuePlace,
//             address: values.address,
//             email: values.email,
//             phone: values.phone,
//             otp: data.code,
//           };

//           subscribeOnce(
//             AccountService.verifyAccount(verifyAccountRequest),
//             () => {
//               addToast({ text: "Tải lên thành công" });
//               dispatch(MyInfoEpic.fetchMyInfo({ destroy$ }));
//             }
//           );
//         }
//       }
//     });
//   };

//   const reloadSignaturePad = () => {
//     signaturePadRef.current?.clear();
//   };

//   return (
//     <div className="w-full p-2">
//       <div className="hidden">
//         <div className="font-bold text-xl">Xác minh KYC</div>
//         <div className="flex">
//           <div className="flex-1">
//             <span className="font-bold">Trạng thái: </span>
//             <span>{IsVerifyName[myInfo.isVerify]}</span>
//           </div>
//           <div className="flex-[2]">
//             {myInfo.reasonFailKyc && (
//               <div>
//                 Lý do thất bại: <span>{myInfo.reasonFailKyc}</span>
//               </div>
//             )}
//           </div>
//         </div>
//         <div className="text-red-500">
//           Lưu ý: Quý khách hãy cung cấp đầy đủ hình ảnh và thông tin theo mẫu
//           bên dưới, sau đó ấn TẢI LÊN để hoàn tất xác minh
//         </div>
//         <div className="mt-2 flex justify-between pr-10 max-[1000px]:flex-wrap max-[1000px]:gap-4">
//           <div className="w-72 max-xl:w-52">
//             <div>1. CCCD mặt trước</div>
//             <div className="w-72 max-xl:w-52 h-52 max-xl:h-32 border border-solid border-red-500">
//               <img
//                 src={frontCardObj}
//                 alt="Chưa chọn ảnh"
//                 className="w-72 max-xl:w-52 h-[206px] max-xl:h-[126px]"
//               />
//             </div>
//             <div className="mt-1">
//               <input
//                 type="file"
//                 name={TypeCard.FRONT_CARD}
//                 className="w-72"
//                 onChange={handleFileChange}
//               />
//             </div>
//             <div className="text-[#D60000B2] text-sm">{frontCardError}</div>
//           </div>
//           <div className="w-72 max-xl:w-52">
//             <div>2. CCCD mặt sau</div>
//             <div className="w-72 max-xl:w-52 h-52 max-xl:h-32 border border-solid border-red-500">
//               <img
//                 src={backCardObj}
//                 alt="Chưa chọn ảnh"
//                 className="w-72 max-xl:w-52 h-[206px] max-xl:h-[126px]"
//               />
//             </div>
//             <div className="mt-1">
//               <input
//                 type="file"
//                 name={TypeCard.BACK_CARD}
//                 className="w-72"
//                 onChange={handleFileChange}
//               />
//             </div>
//             <div className="text-[#D60000B2] text-sm">{backCardError}</div>
//           </div>
//           <div className="w-72 max-xl:w-52">
//             <div>3. Ảnh chân dung</div>
//             <div className="w-72 max-xl:w-52 h-52 max-xl:h-32 border border-solid border-red-500">
//               <img
//                 src={portraitCardObj}
//                 alt="Chưa chọn ảnh"
//                 className="w-72 max-xl:w-52 h-[206px] max-xl:h-[126px]"
//               />
//             </div>
//             <div className="mt-1">
//               <input
//                 type="file"
//                 name={TypeCard.PORTRAIT_CARD}
//                 className="w-72"
//                 onChange={handleFileChange}
//               />
//             </div>
//             <div className="text-[#D60000B2] text-sm">{portraitCardError}</div>
//             <div>
//               <p>Tay trái cầm CCCD/CMT tay phải cầm tờ giấy ghi nội dung: </p>
//               <p>PCRENDER Ngày/tháng/năm hiện tại</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="font-bold mt-2">Thông tin hợp đồng</div>
//       <div>
//         Xem hợp đồng{" "}
//         <a
//           href={myInfo.link_contract ? myInfo.link_contract : "#"}
//           className="text-blue-500 hover:underline"
//           target="_blank"
//           rel="noreferrer"
//         >
//           tại đây
//         </a>
//       </div>
//       <div className="font-bold mt-2">Điền thông tin ký hợp đồng</div>
//       <div className="mt-2">
//         <Formik
//           initialValues={{
//             fullName: "",
//             dob: "",
//             id: "",
//             issueDate: "",
//             issuePlace: "",
//             address: "",
//             email: "",
//             phone: "",
//             isConfirmed: [],
//           }}
//           onSubmit={handleSubmit}
//           innerRef={formRef}
//           validationSchema={verifyValidationSchema}
//           validateOnChange
//           validateOnBlur
//         >
//           <Form>
//             <div className="flex gap-5 flex-wrap">
//               <div className="flex gap-3 flex-col">
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Ông/Bà:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="fullName">
//                       <Input
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Số CCCD:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="id">
//                       <Input
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Địa chỉ:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="address">
//                       <Input
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//               </div>
//               <div className="flex gap-3 flex-col">
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Ngày sinh:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="dob">
//                       <Input
//                         type="date"
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Cấp ngày:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="issueDate">
//                       <Input
//                         type="date"
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Email:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="email">
//                       <Input
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//               </div>
//               <div className="flex gap-3 flex-col">
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Cấp tại:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="issuePlace">
//                       <Input
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <div className="min-w-[80px]">Số ĐT:</div>
//                   <div className="min-w-[200px]">
//                     <FormControl name="phone">
//                       <Input
//                         className="text-sm !max-w-none"
//                         errorClassName="text-sm"
//                       />
//                     </FormControl>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="font-bold mt-2">Ký chữ ký điện tử</div>
//             <div className="mt-2 w-8/12 max-xl:w-10/12 max-sm:w-full">
//               <SignaturePad
//                 ref={signaturePadRef}
//                 canvasProps={{ className: "bg-white" }}
//               />
//               <button
//                 className="bg-blue-500 text-white py-2 px-4 rounded-sm mt-2"
//                 onClick={() => reloadSignaturePad()}
//               >
//                 Ký lại
//               </button>
//             </div>
//             <div className="mt-2">
//               <FormControl name="isConfirmed">
//                 <Checkbox
//                   value="true"
//                   label="Tôi xác nhận"
//                   errorClassName="text-sm"
//                 />
//               </FormControl>
//             </div>
//             <div className="mt-2">
//               <p>
//                 - Đã đọc, hiểu rõ và đồng ý các{" "}
//                 <a
//                   className="text-sm text-[#606266] font-bold hover:underline"
//                   href={PathnameUrl.TERMS}
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   điều khoản
//                 </a>{" "}
//                 trong hợp đồng
//               </p>
//               <p>
//                 - Đảm bảo tính xác thực và chịu trách nhiệm với các thông tin đã
//                 cung cấp: thông tin chủ thể, CMND/CCCD...
//               </p>
//               <p>
//                 - Đồng ý cập nhật chữ ký này vào file hợp đồng của bạn trên
//                 website{" "}
//                 <a
//                   href="https://pcrender.com"
//                   className="text-blue-500 hover:underline"
//                 >
//                   pcrender.com
//                 </a>
//               </p>
//             </div>
//             <div className="mt-2">
//               <Button
//                 type="submit"
//                 label="TẢI LÊN"
//                 width="fit-content"
//                 className="px-7"
//               />
//             </div>
//           </Form>
//         </Formik>
//       </div>
//     </div>
//   );
// }

// const selectMyInfo = (state: GlobalState) => state.myInfo;

// export default IdentityVerification;

import { createRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Formik, FormikContextType } from "formik";
import SignaturePad from "react-signature-pad-wrapper";

import Button from "@app/components/button";
import Checkbox from "@app/components/checkbox";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { addToast } from "@app/components/toast/toast.service";
import VerificationCodeModal from "@app/components/verification-code-modal";
import VerificationModal from "@app/components/verification-modal";
import { PathnameUrl, VerificationMethod } from "@app/constants";
import AccountService from "@app/services/http/account.service";
import AuthService from "@app/services/http/auth.service";
import { openPortalDialog } from "@app/services/modal.service";
import { MyInfoEpic } from "@app/store/my-info";
import { Account, VerifyAccountInitialValues } from "@app/types";
import { verifyValidationSchema } from "@app/validations/account.validation";
import useDestroy from "@core/hooks/use-destroy.hook";
import useObservable from "@core/hooks/use-observable.hook";
import ViewContractModal from "@app/components/view-contract-modal";

function IdentityVerification() {
  const signaturePadRef = createRef<SignaturePad>();
  const formRef = createRef<FormikContextType<VerifyAccountInitialValues>>();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { destroy$ } = useDestroy();
  const { subscribeOnce, subscribeUntilDestroy } = useObservable();

  // 1. State lưu thông tin User trực tiếp từ API
  const [user, setUser] = useState<Account | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [showEkycPrompt, setShowEkycPrompt] = useState<boolean>(false);
  const [showVeriyPhonePrompt, setVerifyPhonePrompt] = useState<boolean>(false);

  // 2. Call API lấy thông tin user mới nhất khi component mount
  useEffect(() => {
    setLoading(true);
    subscribeUntilDestroy(AccountService.getMyInfo(), (res) => {
      setLoading(false);

      if (res) {
        setUser(res);

        // Kiểm tra trạng thái eKYC
        const userVerified = Boolean(res.isVerify === 1 && res.id_card);

        if (!userVerified) {
          setShowEkycPrompt(true);
        }

        if (res.isRequestVerifyPhone === 1 && res.isVerifyPhone === 0) {
          setVerifyPhonePrompt(true);
        }
      }
    });
  }, [subscribeUntilDestroy]);

  // Chuyển hướng sang trang /ekyc
  const handleRedirectToEkyc = () => {
    setShowEkycPrompt(false);
    navigate(PathnameUrl.EKYC_CONSENT);
  };

  const handleRedirectToVerifyPhoneConsent = () => {
    setVerifyPhonePrompt(false);
    navigate(PathnameUrl.VERIFY_PHONE_CONSENT);
  };

  // Submit form ký hợp đồng
  const handleSubmit = (values: VerifyAccountInitialValues) => {
    if (signaturePadRef.current?.isEmpty()) {
      addToast({ text: "Vui lòng ký tên trước khi gửi", status: "inValid" });

      return;
    }

    const verificationModalObs = openPortalDialog(VerificationModal);

    verificationModalObs.afterClosed().subscribe((data) => {
      if (data?.verificationMethod) {
        if (data.verificationMethod[0] === VerificationMethod.EMAIL) {
          subscribeOnce(AuthService.getOtp(), () => {
            handleOpenVerificationCodeModal(values);
          });
        }
      }
    });
  };

  const handleOpenVerificationCodeModal = (
    values: VerifyAccountInitialValues
  ) => {
    if (!signaturePadRef.current) return;

    const signatureImageURL = signaturePadRef.current.toDataURL();
    const verificationCodeModalObs = openPortalDialog(VerificationCodeModal);

    verificationCodeModalObs.afterClosed().subscribe((data) => {
      if (data?.code) {
        const contractPayload: any = {
          signature_image: signatureImageURL,
          fullName: values.fullName,
          dob: values.dob,
          id: values.id,
          issueDate: values.issueDate,
          issuePlace: values.issuePlace,
          address: values.address,
          email: values.email,
          phone: values.phone,
          otp: data.code,
        };

        subscribeOnce(AccountService.verifyAccount(contractPayload), () => {
          addToast({ text: "Ký hợp đồng thành công!" });
          dispatch(MyInfoEpic.fetchMyInfo({ destroy$ }));
          navigate("/");
        });
      }
    });
  };

  const handleViewContract = () => {
    if (!user) {
      return;
    }

    const verificationModalObs = openPortalDialog(VerificationModal);

    verificationModalObs.afterClosed().subscribe((data) => {
      if (data?.verificationMethod) {
        if (data.verificationMethod[0] === VerificationMethod.EMAIL) {
          subscribeOnce(AuthService.getOtp("view_contract"), () => {
            const verificationCodeModalObs = openPortalDialog(
              VerificationCodeModal,
              {
                action: "view_contract",
              }
            );

            verificationCodeModalObs.afterClosed().subscribe((data) => {
              if (data?.code) {
                const viewContractModalObs = openPortalDialog(
                  ViewContractModal,
                  {
                    username: user.username,
                    otp: data.code,
                  }
                );

                viewContractModalObs.afterClosed().subscribe(() => {});
              }
            });
          });
        }
      }
    });
  };

  const reloadSignaturePad = (e: React.MouseEvent) => {
    e.preventDefault();
    signaturePadRef.current?.clear();
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-5xl mx-auto p-4 md:p-6 bg-white rounded-2xl shadow-sm my-4 border border-gray-100">
      {/* MODAL CONFIRM CHƯA EKYC */}
      {showEkycPrompt && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl text-center animate-in fade-in zoom-in duration-200">
            <div className="w-16 h-16 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center mx-auto mb-4 text-3xl">
              ⚠️
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Yêu cầu xác minh danh tính
            </h3>
            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              Tài khoản của bạn chưa thực hiện xác minh danh tính (eKYC). Vui
              lòng hoàn tất xác minh trước khi tiến hành ký hợp đồng.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                type="button"
                onClick={() => navigate("/profile")}
                className="px-5 py-2.5 rounded-xl border border-gray-300 font-semibold text-gray-700 hover:bg-gray-50 transition-all text-sm"
              >
                Quay lại
              </button>
              <button
                type="button"
                onClick={handleRedirectToEkyc}
                className="px-6 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-bold transition-all shadow-md shadow-blue-200 text-sm"
              >
                Xác thực ngay (eKYC)
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CONFIRM CHƯA VERIFY PHONE (CHƯA XÁC MINH SĐT) */}
      {showVeriyPhonePrompt && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl text-center animate-in fade-in zoom-in duration-200">
            <div className="w-16 h-16 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center mx-auto mb-4 text-3xl">
              ⚠️
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              🔐 YÊU CẦU XÁC MINH SỐ ĐIỆN THOẠI
            </h3>
            <br />
            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              Tài khoản của bạn chưa hoàn tất xác minh số điện thoại.
              <br />
              Vui lòng xác minh số điện thoại để tiếp tục sử dụng các dịch vụ
              trên PCRENDER.
              <br />
              👉 Nhấn “Xác minh ngay” để thực hiện xác minh.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                type="button"
                onClick={() => navigate("/profile")}
                className="px-5 py-2.5 rounded-xl border border-gray-300 font-semibold text-gray-700 hover:bg-gray-50 transition-all text-sm"
              >
                Quay lại
              </button>
              <button
                type="button"
                onClick={handleRedirectToVerifyPhoneConsent}
                className="px-6 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-bold transition-all shadow-md shadow-blue-200 text-sm"
              >
                Xác minh ngay
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="border-b border-gray-200 pb-4 mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Ký hợp đồng điện tử
        </h1>
        <p className="text-gray-500 text-sm mt-1">
          Xác nhận thông tin cá nhân và tạo chữ ký điện tử để hoàn tất hợp đồng.
        </p>
      </div>

      {/* Thông tin hợp đồng */}
      <div className="bg-blue-50/60 border border-blue-200 rounded-xl p-4 mb-6 flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <span className="text-blue-600 font-semibold">
            📄 Hợp đồng dịch vụ:
          </span>
          <span className="text-gray-700 font-medium">
            Hợp đồng cung cấp dịch vụ PC Render
          </span>
        </div>
        <div className="text-blue-600 font-semibold">
          Trạng thái hợp đồng:{" "}
          {user?.isSigned ? (
            <span className="text-green-500">Đã ký</span>
          ) : (
            <span className="text-red-600">Chưa ký</span>
          )}
        </div>
      </div>

      {/* Form điền thông tin và chữ ký */}
      <Formik
        enableReinitialize // 👈 Giúp Formik cập nhật lại form khi `initialValues` thay đổi
        initialValues={{
          fullName: user?.fullName || "",
          id: user?.id_card || "",
          dob: user?.dob || "",
          issueDate: user?.issueDate || "",
          issuePlace: user?.issuePlace || "",
          address: user?.address?.replace("\n", " ") || "",
          email: user?.email || "",
          phone: user?.phone || "",
          isConfirmed: [],
        }}
        onSubmit={handleSubmit}
        innerRef={formRef}
        validationSchema={verifyValidationSchema}
        validateOnChange
        validateOnBlur
      >
        <Form className="space-y-6">
          {!user?.isSigned && (
            <div className="bg-gray-50/50 p-5 rounded-2xl border border-gray-200/80">
              <h2 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span>👤</span> Thông tin chủ thể ký hợp đồng
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Họ và tên ông/bà <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="fullName">
                    <Input readOnly className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Ngày sinh <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="dob">
                    <Input readOnly className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Số CCCD/CMND <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="id">
                    <Input readOnly className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Cấp ngày <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="issueDate">
                    <Input readOnly className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Cấp tại <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="issuePlace">
                    <Input readOnly className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Số điện thoại <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="phone">
                    <Input className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Email liên hệ <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="email">
                    <Input readOnly className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>

                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-600 mb-1">
                    Địa chỉ thường trú <span className="text-red-500">*</span>
                  </label>
                  <FormControl name="address">
                    <Input readOnly className="text-sm !max-w-none bg-white" />
                  </FormControl>
                </div>
              </div>
            </div>
          )}

          {/* Khu vực Chữ ký */}
          {!user?.isSigned && (
            <div className="bg-gray-50/50 p-5 rounded-2xl border border-gray-200/80">
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-base font-bold text-gray-900 flex items-center gap-2">
                  <span>✍️</span> Chữ ký điện tử{" "}
                  <span className="text-red-500">*</span>
                </h2>
                <button
                  type="button"
                  className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-1 px-3 rounded-lg transition-all"
                  onClick={reloadSignaturePad}
                >
                  Ký lại
                </button>
              </div>
              <p className="text-xs text-gray-500 mb-3">
                Vui lòng dùng chuột hoặc cảm ứng vẽ chữ ký của bạn vào ô bên
                dưới.
              </p>

              <div className="border w-[50%] max-md:w-[70%] max-md:h-32 border-dashed border-gray-300 rounded-xl overflow-hidden bg-white shadow-inner">
                <SignaturePad
                  ref={signaturePadRef}
                  canvasProps={{
                    className:
                      "w-full h-44 max-md:h-32 bg-white cursor-crosshair",
                  }}
                />
              </div>
            </div>
          )}

          <div
            onClick={handleViewContract}
            className="cursor-pointer inline-flex items-center text-sm font-bold text-blue-600 hover:text-blue-800 hover:underline gap-1"
          >
            Xem file hợp đồng ↗
          </div>

          {/* Đồng ý điều khoản */}
          {!user?.isSigned && (
            <div className="space-y-3 pt-2">
              <FormControl name="isConfirmed">
                <Checkbox
                  value="true"
                  label="Tôi đã đọc và hiểu rõ các điều khoản trong hợp đồng, tôi xác nhận thông tin của tôi cung cấp trong hợp đồng là hoàn toàn chính xác."
                  errorClassName="text-sm text-red-500"
                />
              </FormControl>

              <div className="text-xs text-gray-500 space-y-1.5 pl-1 leading-relaxed">
                <p>
                  • Đã đọc, hiểu rõ và đồng ý các{" "}
                  <a
                    className="text-blue-600 font-semibold hover:underline"
                    href={PathnameUrl.TERMS}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Điều khoản dịch vụ
                  </a>{" "}
                  trong hợp đồng.
                </p>
                <p>
                  • Cam kết tính xác thực và chịu trách nhiệm trước pháp luật về
                  thông tin cá nhân đã cung cấp.
                </p>
                <p>
                  • Đồng ý tích hợp chữ ký điện tử này vào hợp đồng chính thức
                  tại{" "}
                  <a
                    href="https://pcrender.com"
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 font-semibold hover:underline"
                  >
                    pcrender.com
                  </a>
                  .
                </p>
              </div>
            </div>
          )}

          {/* Nút gửi */}
          {!user?.isSigned && (
            <div className="pt-4 border-t border-gray-100 flex justify-end">
              <Button
                type="submit"
                label="HOÀN TẤT & KÝ HỢP ĐỒNG"
                width="fit-content"
                className="px-8 !h-12 text-sm font-bold shadow-lg shadow-blue-100 rounded-xl"
              />
            </div>
          )}
        </Form>
      </Formik>
    </div>
  );
}

export default IdentityVerification;
